import { getService } from 'data/function';
import { catchAction } from '../EventReceiver';
import { EventAction } from '../EventAction';
export class TenantProcessor {
    static get TenantService() {
        return getService('TenantService');
    }
    /**
     * Process command from postMessage event
     * @param payload
     */
    static async process({ message, source, trackingProperties, }) {
        let messageResponse;
        const action = catchAction(message.action);
        switch (action) {
            case EventAction.AddTenantPrefixToUrl:
                messageResponse = {
                    response: TenantProcessor.TenantService.addTenantPrefixToUrl(message.content.url, message.content.tenantId),
                    trackingProperties,
                };
                source.postMessage(messageResponse, '*');
                break;
            case EventAction.GetTenantUrl:
                const url = TenantProcessor.TenantService.getTenantUrl(message.content?.tenantId);
                messageResponse = {
                    url,
                    trackingProperties,
                };
                source.postMessage(messageResponse, '*');
                break;
            case EventAction.GetTenantPlan:
                const tenantPlan = await TenantProcessor.TenantService.getTenantPlan(message.content?.tenantId);
                messageResponse = {
                    tenantPlan,
                    trackingProperties,
                };
                source.postMessage(messageResponse, '*');
                break;
            default:
                throw new Error('Unrecognized TenantService action');
        }
    }
}
